import { gql } from '@apollo/client';
import { VIDEO_FRAGMENT } from 'graphql/secure/fragments';

export const GET_VIDEOS = gql`
  query GetVideos($filters: VideoFilters) {
    videos(filters: $filters) {
      edges {
        node {
          ...videoValues
        }
      }
    }
  }
  ${VIDEO_FRAGMENT}
`;

export const GET_VIDEO = gql`
  query GetVideo($id: UUID!) {
    video(id: $id) {
      ...videoValues
    }
  }
  ${VIDEO_FRAGMENT}
`;

export const GET_VIDEOS_BY_ID = gql`
  query GetVideosById($ids: [UUID]!) {
    videosById(ids: $ids) {
      edges {
        node {
          ...videoValues
        }
      }
    }
  }
  ${VIDEO_FRAGMENT}
`;
